import { takeLeading } from "redux-saga/effects";
import { ChatActionTypes } from "../types";
import { sendMessageRequestSaga } from "./sendMessageSaga";

export default function* chatSaga() {
    yield takeLeading(ChatActionTypes.SEND_MESSAGE_REQUEST, sendMessageRequestSaga);
}
